import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

export const StyledButton = styled.button`
  display: flex;
  gap: 12px;
  align-items: center;

  padding-block: 6px;
  padding-inline: 8px;

  color: #333333;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  white-space: nowrap;

  border: 1px solid #dfdfdf;
  border-radius: 4px;

  background-color: #f8f8f8;

  cursor: pointer;

  svg {
    inline-size: 16px;
    block-size: 16px;
  }

  ${theme.breakpoints.up("desktop")} {
    display: none;
  }
`;
